<template>
          <v-dialog v-model="dialog" @click:outside="close" @keyup.esc="close" scrollable>
            <v-card tile>
              <v-card-title class="grey lighten-3 headline text-break py-2">
                <slot name="title"></slot>
                <v-spacer></v-spacer>
                <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text ref="dialogText" class="pa-0">
                <slot name="body"></slot>
              </v-card-text>
              
              <v-card-actions v-if="!hideDefaultActions" class="pa-3 pt-0">
                <v-btn
                  @click="closeSaveClear"
                  color="primary lighten-1"
                  min-width="150"
                  :loading="saving"
                  :disabled="saving"
                >
                  Ok
                </v-btn>
                <v-btn @click="close" color="primary lighten-1" outlined min-width="150">Cancel</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'EditDialog',
  components: {
    
  },
  props: {
      valid: Boolean,
      dialog: Boolean,
      hideDefaultActions: Boolean,
      saving: Boolean
  },
  data: () =>  ({
    
  }),

  methods: {
    closeSaveClear() {      
      this.goToTop();
      this.$emit('save');
    },
    close() {
      this.goToTop();
      this.$emit('close');
    },
    goToTop( ){
      this.$refs.dialogText.scrollTop=0;
    }
      
  }
}
</script>
